import { ClientConfig, ClientConfigOptions } from '../../clientConfig';
import { Request } from '../../common/request';
import { ApiResult } from '../../common/types';
import { 
   AddEnterpriseAuthenticationParams, 
   EnterpriseAuthParams, 
   CorporateAttestationParams, 
   CorporateSubmitAuthenticationParams,
   SendSmsParams
} from './model';

/**
 * 企业客户端类
 * 提供企业相关的API操作，包括企业认证、信息管理等功能
 * @class EnterpriseClient
 */
export class EnterpriseClient {
   /** 客户端配置 */
   private config: ClientConfig;
   /** HTTP请求服务 */
   private service: Request;

   /**
    * 创建企业客户端实例
    * @param {ClientConfigOptions} options - 客户端配置选项
    */
   constructor(options: ClientConfigOptions) {
      this.config = new ClientConfig(options);
      this.service = new Request(this.config.getConfig());
   }

   /**
    * 企业入驻并发送认证链接
    * 创建企业账户并向法人和经办人发送认证链接
    * 
    * @param {AddEnterpriseAuthenticationParams} params - 请求参数对象
    * @returns {Promise<ApiResult>} 企业入驻结果
    */
      getAddEnterpriseAuthentication(params: AddEnterpriseAuthenticationParams): Promise<ApiResult> {
         return this.service.post(`/openAPI/enterprise/getAddEnterpriseAuthentication`, params);
      }


   /**
    * 机构实名认证---接口认证
    * 
    * @param {EnterpriseAuthParams} params - 请求参数对象
    * @returns {Promise<ApiResult>} 企业入驻结果
    */
   enterpriseAuth(params: EnterpriseAuthParams): Promise<ApiResult> {
      return this.service.post(`/openAPI/enterprise/v1/enterprise/auth`, params);
   }
   
   /**
    * 对公打款认证--填写企业信息及对公信息
    * 
    * @param {CorporateAttestationParams} params - 请求参数对象
    * @returns {Promise<ApiResult>} 企业入驻结果
    */
   getCorporateAttestation(params: CorporateAttestationParams): Promise<ApiResult> {
      return this.service.post(`/openAPI/enterprise/getCorporateAttestation`, params);
   }

   /**
    * 对公打款认证--填写打款金额完成认证
    * 
    * @param {CorporateSubmitAuthenticationParams} params - 请求参数对象
    * @returns {Promise<ApiResult>} 企业入驻结果
    */
   getCorporateSubmitAuthentication(params: CorporateSubmitAuthenticationParams): Promise<ApiResult> {
        const processedParams = {
         ...params,
         remittanceMoney: Number.isInteger(params.remittanceMoney) 
            ? `${params.remittanceMoney}.0` 
            : String(params.remittanceMoney)
      };
      return this.service.post(`/openAPI/enterprise/getCorporateSubmitAuthentication`, processedParams);
   }

      /**
    * 发送短信验证码
    * 发送短信验证码到指定手机号
    * 
    * @param {SendSmsParams} params - 请求参数对象
    * @returns {Promise<ApiResult>} 短信验证码信息
    */
      async sendSms(params: SendSmsParams): Promise<ApiResult> {
         return this.service.post('/openAPI/v2/api/send_sm', params);
      }
}
